
import { getGlobalStorage, setGlobalStorage, ajax, pageTo } from '@platform/api';

export function splitPks(data, pageIndex, pageSize){
    if (!data?.length || data.length <= pageSize) {
        // 这里暂时解决问题，后续在进行优化
        return data;
    }
    let pks = [];
    let index = Number(pageIndex);
    let size = Number(pageSize);
    let start = index * size;
    for (let i = start; i < start + size; i++) {
        if (data[i]) {
            pks.push(data[i]);
        } else {
            break;
        }
    }
    return pks;
}

export function getAutoWrap(store, id){
    let savedKey = getLocalStorageKey(store, id, 'foldFlag');
    let savedValue = getGlobalStorage('localStorage', 'fold_flag') || {};
    if(typeof savedValue === 'string'){
        savedValue = JSON.parse(savedValue);
    }
    return !!savedValue?.[savedKey];
}

export function generateColSettingConfig(store, id){ //store可能传的是meta，某些时机取不到store
    let meta = store?.getInstance? store.getInstance().store.meta : store;
    if(!meta || !meta[id]) {return {};}
    return {
        appCode: meta[id].appcode || pageTo.getAppCode(),
        pageCode: meta[id].pagecode || pageTo.getPageCode(),
        code: meta[id].templateCode || meta.code,
        pageId: meta[id].pageid || meta.pageid,
        areaCode: id,
        areaId: meta[id].oid,
    };
}

export function _generateColSettingConfig(meta, id){ //store可能传的是meta，某些时机取不到store
    if(!meta || !meta[id]) {return {};}
    return {
        appCode: meta[id].appcode || pageTo.getAppCode(),
        pageCode: meta[id].pagecode || pageTo.getPageCode(),
        code: meta[id].templateCode || meta.code,
        pageId: meta[id].pageid || meta.pageid,
        areaCode: id,
        areaId: meta[id].oid,
    };
}

export function setAutoWrap(store, id, flag){
    let savedKey = getLocalStorageKey(store, id, 'foldFlag');
    let savedValue = getGlobalStorage('localStorage', 'fold_flag');
    if (savedValue) {
        savedValue = JSON.parse(savedValue);
    } else {
        savedValue = {};
    }
    savedValue = {
        ...savedValue,
        [savedKey]: flag,
    };

    setGlobalStorage('localStorage', 'fold_flag', JSON.stringify(savedValue));
}

export function setColumnsToServer(store, id, columns, callback){
    let config = generateColSettingConfig(store, id);
    ajax({
        url: '/nccloud/platform/template/propertySetting.do',
        data: {
            appcode: config.appCode || pageTo.getAppCode(),
            pagecode: config.pageCode || pageTo.getPageCode(),
            templatecode: config.code,
            templateId: config.pageId,
            [id]: {
                areaId: config.areaId,
                items: columns,
            },
        },
        success: res => {
            callback?.(res.success);
        },
    });
}

export function getColumnsFormServer(store, id, callback){
    let config = generateColSettingConfig(store, id);
    ajax({
        url: '/nccloud/platform/template/getUserTemplateMap.do',
        async: true,
        data: {
            appcode: config.appCode || pageTo.getAppCode(),
            pagecode: config.pageCode || pageTo.getPageCode(),
            templatecode: config.code,
            templateId: config.pageId,
        },
        success: res => {
            let columns = res.data[0].areaList.filter(item => item.code === id)[0].formPropertyList;
            let columnsWithSort = res.data[1][id].items;
            callback?.(columns, columnsWithSort);
        },
    });
}

export function setLocalStorageColumnsWidth(store, id, columns){
    let key = getLocalStorageKey(store, id, 'customer_col_width');
    setGlobalStorage('localStorage', key, JSON.stringify(columns));
}

export function getLocalStorageColumnsWidth(store, id){
    let key = getLocalStorageKey(store, id, 'customer_col_width');
    let columnsJson = getGlobalStorage('localStorage', key);
    return JSON.parse(columnsJson) || [];
}

export function getCustomerColumnWidth(store, id, colKey, defaultWidth){
    let widths = getLocalStorageColumnsWidth(store, id);
    return Number(widths[colKey]) || defaultWidth;
}

export function getLocalStorageKey(store, id, prefix) { //注意:getLocalStorageKey有3份(store.js  handleProps, createPage 写了三份一样的代码)
    let keyParam = generateColSettingConfig(store, id);
    let userDataJSON = getGlobalStorage('localStorage', "STOREFORINFODATA");
    let userData = userDataJSON && JSON.parse(userDataJSON);
    let userId = userData && userData.userId;
    let savedKey = `${prefix}_${keyParam.appCode}_${keyParam.pageCode}_${keyParam.areaCode}_${keyParam.code}_${userId}`;

    return savedKey;
}

export function _getLocalStorageKey(meta, id, prefix) {
    let keyParam = _generateColSettingConfig(meta, id);
    let userDataJSON = getGlobalStorage('localStorage', "STOREFORINFODATA");
    let userData = userDataJSON && JSON.parse(userDataJSON);
    let userId = userData && userData.userId;
    let savedKey = `${prefix}_${keyParam.appCode}_${keyParam.pageCode}_${keyParam.areaCode}_${keyParam.code}_${userId}`;

    return savedKey;
};

export function getRowHeight(defaultRowHeight = 28, customTableType) {
    let globalTableConfig = JSON.parse(getGlobalStorage('localStorage', 'nccTable')) || {};
    let { tableType } = globalTableConfig;
    tableType = customTableType || tableType;
    switch (tableType) {
        // 紧凑
        case 'compact':
            return 24;
        // 标准
        case 'standard':
            return 28;
        // 宽松
        case 'loose':
            return 36;
        default: 
            return defaultRowHeight;
    }
}